import ReturnPageButton from './ReturnPageButton'

export default ReturnPageButton



// WEBPACK FOOTER //
// ./src/components/ReturnPageButton/index.js